import D from "@/admin/dashboard/Dashboard.module.css";

import { Bar } from "@/admin/dashboard/Bar.tsx";
import type { AdminHostWithType } from "@/admin/hosts/hostQuery.ts";
import { cn } from "@/utils/classNames.ts";
import { sortBy } from "remeda";

function ipToSortKey(ip: string): string {
    return ip
        .split(".")
        .map((num) => `000${num}`.slice(-3))
        .join("");
}

export function BarChart({ items }: { items: AdminHostWithType[] }) {
    const isShort = items.length > 10;
    const chartItems = sortBy(items, (item) => ipToSortKey(item.ip)).map((item) => (
        <Bar isShort={isShort} item={item} key={item.uuid} />
    ));

    return <div className={cn(D.BarChart, isShort ? "gap-1" : "gap-2")}>{chartItems}</div>;
}
